export default __webpack_public_path__ + "f4f5b3579974c1334c5ce78eeee51c92.png";